import { parseThemeSetting, resolveThemeId, applyThemeToDom } from 'src/theme/helpers.ts';

const KEY = 'adnz_themeId';

const THEME_COLOR: Record<'primary' | 'primaryDark', string> = {
  primary: '#F2F2F3',
  primaryDark: '#232325',
};

function safeGetThemeSetting(key: string) {
  try {
    return parseThemeSetting(localStorage.getItem(key));
  } catch {
    return null;
  }
}

function loadTheme() {
  const setting = safeGetThemeSetting(KEY);
  const id = resolveThemeId(setting);

  applyThemeToDom(id, THEME_COLOR[id] ?? THEME_COLOR.primary);
}

if (import.meta.env.VITE_LOAD_THEME) {
  loadTheme();
}
